import React from 'react';
import PropTypes from 'prop-types';
import { BaasicButton, BaasicFormControls} from "core/components";
import { defaultTemplate } from 'core/hoc';
import { BaasicFieldDropdown } from "core/components";

function CreateFacilityOrderTemplateNewPatientNewFlowModalTemplate({ createFacilityOrderTemplateNewPatientNewFlowModalStore, t }) {
    const {
        form,
        modalParams,
        disabled,
        subCategoryStore
    } = createFacilityOrderTemplateNewPatientNewFlowModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Create a new order</h3>
            </div>

            <p className='u-mar--bottom--sml'>This is an existing patient that isn’t shown on the screen because the patient doesn’t have an Enteral template.</p>

            <div className="modal__body">
                <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} disabled={disabled}/>
            </div>
            <div className='modal__footer is-right'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                    disabled={form.submitting || form.validating}
                />
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Create"
                    className='btn btn--med btn--primary'
                />
            </div>
        </section >
    )
}

CreateFacilityOrderTemplateNewPatientNewFlowModalTemplate.propTypes = {
    createFacilityOrderTemplateNewPatientNewFlowModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(CreateFacilityOrderTemplateNewPatientNewFlowModalTemplate);
